import $axios from '../services/api.js'

const state = () => ({
    total_post: 0,
    total_pages: 0,
    homepage_post: [],
    posts: [],
    post_single: {},
})

const mutations = {
    ASSIGN_TOTAL_POST(state, payload) {
        state.total_post = payload
    },
    ASSIGN_TOTAL_PAGES(state, payload) {
        state.total_pages = parseInt(payload)
    },
    ASSIGN_HOMEPAGE_POST(state, payload) {
        state.homepage_post = payload
    },
    ASSIGN_POST_DATA_INITAL(state, payload) {
        state.posts = payload
    },
    ASSIGN_POST_DATA(state, payload) {
        state.posts = state.posts.concat(payload)
    },
    ASSIGN_POST_SINGLE(state, payload) {
        state.post_single = payload
    },
}

const actions = {
    getHomepagePost({ commit }) {
        return new Promise((resolve) => {
            $axios.get(`/posts?_embed&per_page=5`)
                .then((response) => {
                    commit('ASSIGN_TOTAL_POST', response.headers['x-wp-total'])
                    commit('ASSIGN_HOMEPAGE_POST', response.data)
                    resolve(response.data)
                })
        })
    },
    getPost({ commit }) {
        return new Promise((resolve) => {
            $axios.get(`/posts?_embed&per_page=5`)
                .then((response) => {
                    commit('ASSIGN_TOTAL_POST', response.headers['x-wp-total'])
                    commit('ASSIGN_TOTAL_PAGES', response.headers['x-wp-totalpages'])
                    commit('ASSIGN_POST_DATA_INITAL', response.data)

                    resolve(response)
                })
        })
    },
    getPostLoadMore({ commit }, nextUrl) {
        return new Promise((resolve) => {
            $axios.get(`/posts?_embed&per_page=5&page=${nextUrl}`)
                .then((response) => {
                    commit('ASSIGN_POST_DATA', response.data)
                    resolve(response)
                })
        })
    },
    getPostSingle({ commit }, slugUrl) {
        return new Promise((resolve) => {
            $axios.get(`/posts?_embed&slug=${slugUrl}`)
                .then((response) => {
                    commit('ASSIGN_POST_SINGLE', response.data[0])
                    resolve(response.data[0])
                })
        })
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}